import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Projects from '../components/Projects';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  // 1. Define your data here
  const companyData = {
    name: "KIANA DEVELOPERS",
    tagline: "Building Dreams, Creating Landmarks",
    experience: "20+ Years",
    projects: "10+ Completed",
    customers: "2,000+ Happy Families",
    awards: "5+ Industry Awards",
    phone: "+91 9561774777"
  };

  useEffect(() => {
    console.log("Home Section Loaded with data:", companyData.name);
  }, []);

  return (
    <div className="relative">
      <Header />
      
      {/* 2. Pass the data object into the Hero component */}
      <div id="home" className="scroll-mt-20">
        <Hero company={companyData} />
      </div>

      <section id="about" className="scroll-mt-20">
        <About />
      </section>

      <section id="projects" className="scroll-mt-20">
        <Projects />
      </section>

      <section id="testimonials" className="scroll-mt-20">
        <Testimonials />
      </section>

      <section id="contact" className="scroll-mt-20">
        <Contact />
      </section>

      <Footer />
    </div>
  );
};

export default Home;